import { Stack } from '@mui/material'

interface P {
    url: string
    alt?: string
}

const ImageViewer = ({ url, alt }: P) => {
    return (
        <Stack style={{ overflow: 'hidden' }}>
            <img
                src={url}
                alt={alt}
                style={{
                    overflow: 'hidden',
                    objectFit: 'scale-down',
                    borderRadius: '8px',
                    boxShadow: '0 4px 10px rgba(101, 148, 48, 0.1)'
                }}
            />
        </Stack>
    )
}

export default ImageViewer
